import React from 'react';
import './About.css';

const About = () => {
  return (
    <div className="about-page">
      <div className="about-hero">
        <div className="container">
          <div className="header-content">
            <i className="fas fa-building"></i>
            <h1>אודותינו</h1>
          </div>
        </div>
      </div>

      <section className="about-content">
        <div className="container">
          <div className="about-card">
            <div className="about-section">
              <p className="about-text">
                באוטוקרוס יבואני רכב, אנו מתחייבים לשירות אישי, אמינות בלתי מתפשרת וליווי מקצועי לאורך כל הדרך.
              </p>
            </div>

            <div className="about-section">
              <p className="about-text">
                אנחנו יודעים שרכישת רכב – במיוחד מונית – מלווה בשאלות רבות, בהתלבטויות ובחיפוש אחר העסקה המשתלמת ביותר.
                לכן אנו כאן בשבילכם, נהגי המוניות היקרים: לייעץ, לכוון, ולהפוך את תהליך הרכישה לפשוט, ברור ובעיקר – משתלם.
              </p>
            </div>

            <div className="about-section">
              <h2>אז מה זה בעצם יבואן מקביל?</h2>
              <p className="about-text">
                יבואן מקביל עומד בדרישות התקן המחמירות ביותר, ומאפשר לכם ליהנות מרכב חדש במחיר אטרקטיבי, עם אחריות מלאה של היבואן הרשמי.
                כך שאתם חוסכים פערי תיווך מיותרים – ומקבלים רכב איכותי, אמין ומשתלם.
              </p>
            </div>

            <div className="about-section">
              <p className="about-text">
                באוטוקרוס כל הרכבים חדשים לגמרי, עם רישום בעלות (00) – כלומר, אתם הבעלים הראשונים והבלעדיים.
                אנו מייבאים את הדגמים החדישים והבטוחים ביותר, עם כל התוספות המקוריות ישירות מהיצרן – כדי להבטיח לכם שקט נפשי לאורך שנים.
              </p>
            </div>

            <div className="about-section">
              <p className="about-text highlight">
                בואו ליהנות משירות מקצועי, יחס אישי וחוויית קנייה שמכוונת רק למטרה אחת – שאתם תצאו מרוצים.
              </p>
            </div>

            <div className="cta-buttons">
              <a href="tel:97233820232" className="cta-button phone-button">
                <i className="fas fa-phone-alt"></i>
                התקשר עכשיו
              </a>
              <a href="https://wa.me/97233820232" target="_blank" rel="noopener noreferrer" className="cta-button whatsapp-button">
                <i className="fab fa-whatsapp"></i>
                WhatsApp
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About; 